import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { IoIosArrowDown } from "react-icons/io";
import { ErrorMessage, Field, FieldArray } from "formik";
import { BiTrash } from "react-icons/bi";
import { VscDiffAdded } from "react-icons/vsc";
import { CommonAxiosGet } from "../../../CommonUtilities/CommonAxios/CommonAxios";
import { config } from "../../../CommonUtilities/CommonUrl/CommonUrls";
import { CURRENT_ACADEMIC_YEAR } from "../../../CommonUtilities/Validations/RegularExpAndVar";
import { dedCourses, pgDegreeBasedCourses } from "./ApplicationForm";
import { calculatePercentage } from "../../../CommonUtilities/CommonFunctions/CommonFunction";

const validCourseCodes = ["Q105", "Q106", "Q107", "Q108", "Q109", "Q110"];
const integratedPqCodes = ["40", "42", "46", "47", "44", "43"];
export const isIntegratedPq = (value) => integratedPqCodes.includes(value);

export const isIntegrated = (value) => validCourseCodes.includes(value);


export function handleUnivFilter(
  course_code,
  index,
  setUniv,
  showpqcourse,
  showUniversities
) {
  let univ_code = showpqcourse?.filter(
    (val) => val.id === parseInt(course_code)
  )[0]?.univ_code;
  let data = showUniversities
    ?.filter((val) => val.univ_code === univ_code)
    ?.map((ds, i) => {
      return (
        <option key={i} value={ds.univ_code}>
          {ds.univ_name}
        </option>
      );
    });
  if (data.length > 0) {
    setUniv((prevState) => ({
      ...prevState,
      [index]: data,
    }));
  } else {
    setUniv((prevState) => ({
      ...prevState,
      [index]: showUniversities?.map((ds, i) => {
        return (
          <option key={i} value={ds.univ_code}>
            {ds.univ_name}
          </option>
        );
      }),
    }));
  }
}
export default function ProfessionQualification(props) {

  const { Formik, years, showPqData, showUniversities } = props;

     useEffect(() => {
      const pqList = Formik.values.pq || [];
      pqList?.forEach((item, index) => {
        const percent = calculatePercentage(
          item?.marksSecured,
          item?.totalMarks
        );
        if (item.percentage !== percent) {
          Formik.setFieldValue(`pq[${index}].percentage`, percent);
        }
      });
    }, [Formik.values.pq]);

  const [showpqsub, setpqsub] = useState({});
  useEffect(() => {
    if (showPqData && showPqData?.length > 0) {
      showPqData?.forEach((data, index) => {
        const yearOfPass = data?.year_of_pass;
        Formik.setFieldValue(`pq[${index}].yearOfPass`, data?.year_of_pass);
         Formik.setFieldValue(`pq[${index}].totalMarks`, data?.total_marks);
        Formik.setFieldValue(`pq[${index}].marksSecured`, data?.marks_secured);
        Formik.setFieldValue(`pq[${index}].percentage`, calculatePercentage(data?.marks_secured, data?.total_marks  ));
        Formik.setFieldValue(`pq[${index}].courseCode`, data.course_code);
        Formik.setFieldValue(`pq[${index}].subject1`, data?.subject_1);
        Formik.setFieldValue(`pq[${index}].subject2`, data?.subject_2);
        handleUnivFilter(data.course_code, index, setUniv, showpqcourse, showUniversities);
        Formik.setFieldValue(`pq[${index}].univCode`, data.univ_code);
        Formik.setFieldValue(`pq[${index}].mediumId`, data?.medium_id);
      });
    }
  }, [showPqData]);
  // ***********Universities Get***********//
  const [showPqSubjects, setPqSubjects] = useState([])
  const getpqsubData = () => {
    let Url = config.url.CONTEXT_READ_URL + "prof-subjects?course_code=0"
    //+ value;
    CommonAxiosGet(Url).then((res) => {
      if (res?.data?.status === true) {
        setPqSubjects(res?.data?.profsubjects)
        //     let options = res?.data?.profsubjects?.map((ds, i) => {
        //       return (
        //         <option key={i} value={ds.id}>{ds.subject}</option>
        //       );
        //     });
        //     setpqsub((prevState) => ({ ...prevState, [index]: options, }));
        //     Formik.setFieldValue(`selectedCourses[${index}]`, options);
      } else {
        setPqSubjects([])
        // Formik.setFieldValue(`selectedCourses[${index}]`, []);
        // setpqsub((prevState) => ({ ...prevState, [index]: [], }));
      }
    });
  };
  useEffect(() => { getpqsubData() }, [showPqData])



  const [showpqcourse, setpqcourse] = useState([]);

  function getpqcourseData() {
    let Url = config.url.CONTEXT_READ_URL + "prof-courses";
    CommonAxiosGet(Url).then((res) => {
      if (res?.data?.status === true) {
        let data = res?.data?.profcourses;
        // console.log("prof",data)
        let is_ug = Formik?.values?.isUg;
        let is_pg = Formik?.values?.isPg;

        let filtered_data = data?.filter((val) =>
          !pgDegreeBasedCourses.includes(val?.id)
        );
        setpqcourse((is_ug === 'Yes' || is_pg === 'Yes') ? data : filtered_data);
      } else {
        setpqcourse([]);
      }
    });
  }
  useEffect(() => {
    getpqcourseData();
  }, [Formik?.values?.isUg, Formik?.values?.isPg]);

  const [showUniv, setUniv] = useState({});

  //if inter is no then ded  related courses should be delete from pq
  useEffect(() => {
    if (Formik.values.isInter === "No") {
      const filtered = Formik.values.pq.filter(
        (row) => !dedCourses.includes(Number(row.courseCode))
      );
      Formik.setFieldValue("pq", filtered);
    }
  }, [Formik.values.isInter]);

  return (
    <div className="personal-block mb-2">
      <div className="personal-head">
        <span> Professional Qualification </span>
      </div>
      <div className="personal-row mb-2">
        <div className="table-responsive px-3 mb-3">
          <table
            className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
            style={{ borderCollapse: "collapse" }}
          >
            <thead>
              <tr>
                <td>
                  <Form.Label className="input-lable mb-2">
                    Qualification<font color="red">*</font>{" "}
                  </Form.Label>
                </td>
                <td>
                  <Form.Label className="input-lable mb-2">
                    University <font color="red">*</font>
                  </Form.Label>
                </td>
                {/* <td>
                  <Form.Label className="input-lable mb-2">
                    Medium <font color="red">*</font>
                  </Form.Label>
                </td> */}
                <td>
                  <Form.Label className="input-lable mb-2">
                    Methodology 1<font color="red">*</font>
                  </Form.Label>
                </td>

                <td>
                  <Form.Label className="input-lable mb-2">
                    Methodology 2
                  </Form.Label>
                </td>
                 <td>
                  <Form.Label className="input-lable mb-2">
                    Medium <font color="red">*</font>
                  </Form.Label>
                </td>
                <td>
                  <Form.Label className="input-lable mb-2">
                    Year of Passing <font color="red">*</font>
                  </Form.Label>
                </td>
                <td>
                  <Form.Label className="input-lable mb-2">
                    Total Marks <font color="red">*</font>
                  </Form.Label>
                </td>
                 <td>
                  <Form.Label className="input-lable mb-2">
                    Marks Secured <font color="red">*</font>
                  </Form.Label>
                </td>
                <td>
                  <Form.Label className="input-lable mb-2">
                    % of marks (including languages)<font color="red">*</font>{" "}
                  </Form.Label>
                </td>

                  <td></td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <FieldArray name="pq">
                {(formikFieldArray) => {
                  // const restrictedQualIds = [19, 27, 28, 52];
                  return formikFieldArray.form.values.pq?.map(
                    (experienceDetails, index) => {
                      {/* console.log("isintegreated>>>",isIntegrated(index, Formik)) */ }
                      //const qualificationId = Formik.values.pq[index]?.courseCode;
                      // const hideSanskrit = restrictedQualIds.includes(Number(qualificationId));
                      return (
                        <tr id={index} key={index}>
                          <td>
                            <div className="input-div position-relative">
                              <Form.Group>
                                <Field
                                  as="select"
                                  className="input-field form-control"
                                  name={`pq[${index}].courseCode`}
                                  disabled={integratedPqCodes?.includes(experienceDetails?.courseCode + '')}
                                  onChange={(e) => {
                                    // console.log("e>>", e.target.value)
                                    let val = e.target.value;
                                    // getpqsubData(val, index);
                                    handleUnivFilter(
                                      val,
                                      index,
                                      setUniv,
                                      showpqcourse,
                                      showUniversities
                                    );
                                    Formik.setFieldValue(
                                      `pq[${index}].univCode`,
                                      ""
                                    );
                                    Formik.setFieldValue(
                                      `pq[${index}].subject1`,
                                      ""
                                    );
                                    Formik.setFieldValue(
                                      `pq[${index}].subject2`,
                                      ""
                                    );
                                     Formik.setFieldValue(
                                      `pq[${index}].totalMarks`,
                                      ""
                                    );
                                      Formik.setFieldValue(
                                        `pq[${index}].marksSecured`,
                                        ""
                                      );


                                  }}
                                >
                                  <option value="">Select</option>
                                  {showpqcourse?.map((ds, i) => {
                                    return (
                                      <option key={i} value={ds.id}
                                        disabled={integratedPqCodes?.includes(ds.id + '') || Formik?.values?.pq?.some(item => String(item.courseCode) === String(ds.course_code) ||
                                          (Formik?.values?.isInter === "No" && dedCourses.includes(ds.id)))}>
                                        {ds.course}
                                      </option>
                                    );
                                  })}
                                </Field>
                                <ErrorMessage
                                  name={`pq[${index}].courseCode`}
                                  component="div"
                                  className="text-error"
                                />
                              </Form.Group>
                              <IoIosArrowDown className="dropdown-icon" />
                            </div>
                          </td>
                          <td>
                            <div className="input-div position-relative">
                              <Form.Group>
                                <Field
                                  as="select"
                                  className="input-field form-control"
                                  name={`pq[${index}].univCode`}
                                  disabled={integratedPqCodes?.includes(experienceDetails?.courseCode + '')}
                                >
                                  <option value="">---select---</option>
                                  {/* {
                                    !isIntegrated(index, Formik)? 
                                    showUniversities?.map((ds, i) => (
                                      <option key={i} value={ds.univ_code}>
                                        {ds.univ_name}
                                      </option>
                                    ))
                                    : showUniv[index]} */}
                                  {showUniversities?.map((ds, i) => (
                                    <option key={i} value={ds.univ_code}>
                                      {ds.univ_name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name={`pq[${index}].univCode`}
                                  component="div"
                                  className="text-error"
                                />
                              </Form.Group>
                              <IoIosArrowDown className="dropdown-icon" />
                            </div>
                          </td>
                        
                          <td>
                            <div className="input-div position-relative">
                              <Form.Group>
                                <Field
                                  as="select"
                                  className="input-field form-control"
                                  name={`pq[${index}].subject1`}
                                >
                                  <option value="">Select</option>
                                  {/* {integratedPqCodes?.includes(experienceDetails?.courseCode + '')
                                    ? Formik?.values?.selectedCourses[index]
                                    : showpqsub[index]} */}
                                  {showPqSubjects?.filter((val) => val?.course_code == experienceDetails?.courseCode)?.map((ds, i) => (
                                    <option key={i} value={ds.id}>{ds.subject}</option>))}

                                  {/* {console.log(`${index}::::`,integratedPqCodes?.includes(experienceDetails?.courseCode + '')
                                    ? Formik?.values?.selectedCourses[index]
                                    : showpqsub[index])} */}
                                </Field>
                                <ErrorMessage
                                  name={`pq[${index}].subject1`}
                                  component="div"
                                  className="text-error"
                                />
                              </Form.Group>
                              <IoIosArrowDown className="dropdown-icon" />
                            </div>
                          </td>
                          <td>
                            {Formik.values.pq[index]?.courseCode !== "19" &&
                              Formik.values.pq[index]?.courseCode !== "20" &&
                              Formik.values.pq[index]?.courseCode !== "72" &&
                              showpqsub[index]?.length !== 1 && (
                                <div className="input-div position-relative">
                                  <Form.Group>
                                    <Field
                                      as="select"
                                      className="input-field form-control"
                                      name={`pq[${index}].subject2`}
                                    >
                                      <option value="">Select</option>
                                      {/* {integratedPqCodes?.includes(experienceDetails?.courseCode + '')
                                        ? Formik?.values?.selectedCourses[index]
                                        : showpqsub[index]} */}
                                      {showPqSubjects?.filter((val) => val?.course_code == experienceDetails?.courseCode)?.map((ds, i) => (
                                        <option key={i} value={ds.id}>{ds.subject}</option>))}
                                    </Field>
                                    <ErrorMessage
                                      name={`pq[${index}].subject2`}
                                      component="div"
                                      className="text-error"
                                    />
                                  </Form.Group>
                                  <IoIosArrowDown className="dropdown-icon" />
                                </div>
                              )}
                          </td>
                            <td>
                            <div className="input-div position-relative">
                              <Form.Group>
                                <Field
                                  as="select"
                                  className="input-field form-control"
                                  disabled={integratedPqCodes?.includes(experienceDetails?.courseCode + '')}
                                  name={`pq[${index}].mediumId`}
                                >
                                  <option value="">Select</option>
                                  <option value="1">TELUGU</option>
                                  <option value="2">URDU</option>
                                  <option value="3">HINDI</option>
                                  <option value="4">KANNADA</option>
                                  <option value="5">ORIYA</option>
                                  <option value="6">TAMIL</option>
                                  <option value="7">ENGLISH</option>
                                </Field>
                                <ErrorMessage
                                  name={`pq[${index}].mediumId`}
                                  component="div"
                                  className="text-error"
                                />
                              </Form.Group>
                              <IoIosArrowDown className="dropdown-icon" />
                            </div>
                          </td>
                          <td>
                            <div className="input-div position-relative">
                              <Form.Group>
                                <Field
                                  as="select"
                                  className="input-field form-control"
                                  name={`pq[${index}].yearOfPass`}
                                  disabled={integratedPqCodes?.includes(experienceDetails?.courseCode + '')}
                                  onChange={() => {
                                    Formik.setFieldValue(
                                      `pq[${index}].percentage`,
                                      ""
                                    );
                                    Formik.setFieldValue(
                                      `pq[${index}].hasFinalYearResult`,
                                      ""
                                    );
                                  }}
                                >
                                  <option value="">Select</option>
                                  {years?.map((year) => (
                                    <option key={year} value={year}>
                                      {year}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name={`pq[${index}].yearOfPass`}
                                  component="div"
                                  className="text-error"
                                />
                              </Form.Group>
                              <IoIosArrowDown className="dropdown-icon" />
                            </div>
                          </td>
                          <td>
                            <Form.Group>
                              <Field
                                type="text"
                                name={`pq[${index}].totalMarks`}
                                className="input-field form-control"
                                maxLength="4"
                              />
                              <ErrorMessage
                                name={`pq[${index}].totalMarks`}
                                component="div"
                                className="text-error"
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Field
                                type="text"
                                name={`pq[${index}].marksSecured`}
                                className="input-field form-control"
                                maxLength="4"
                              />
                              <ErrorMessage
                                name={`pq[${index}].marksSecured`}
                                component="div"
                                className="text-error"
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Field
                                type="text"
                                name={`pq[${index}].percentage`}
                                className="input-field form-control"
                                maxLength="4"
                              />
                              <ErrorMessage
                                name={`pq[${index}].percentage`}
                                component="div"
                                className="text-error"
                              />
                            </Form.Group>
                          </td>
                          <td></td>
                          <td className="text-end">
                            {(!integratedPqCodes?.includes(experienceDetails?.courseCode + '') && Formik.values.pq.length >= 2) ? (
                              <>
                                <button
                                  type="button"
                                  className="button-titile btn btn-sm btn-danger mb-2"
                                  onClick={() => {
                                    formikFieldArray.remove(index);
                                    setUniv((prevState) => ({
                                      ...prevState,
                                      [index]: [],
                                    }));
                                    setpqsub((prevState) => ({
                                      ...prevState,
                                      [index]: [],
                                    }));
                                  }}
                                >
                                  <BiTrash
                                    style={{ fontSize: "20px" }}
                                  ></BiTrash>
                                </button>
                              </>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      );
                    }
                  );
                }}
              </FieldArray>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={8}>
                  {/* <div className=" text-error" style={{ fontSize: "15px" }}>
                    Note : Candidates pursuing their final year don’t need to
                    enter % of marks.
                  </div> */}
                </td>
                <td className="text-end">
                  <FieldArray name="pq">
                    {(formikFieldArray) => (
                      <button
                        type="button"
                        className="button-titile btn btn-sm btn-success mb-2 btn-end"
                        onClick={() =>
                          formikFieldArray.push({
                            courseCode: "",
                            univCode: "",
                            subject1: "",
                            subject2: "",
                            yearOfPass: "",
                            percentage: "",
                            mediumId: "",
                            totalMarks: "",
                            marksSecured: "",
                          })
                        }
                      >
                        <VscDiffAdded
                          style={{ fontSize: "20px" }}
                        ></VscDiffAdded>
                      </button>
                    )}
                  </FieldArray>{" "}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
}
